import React, { useState } from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import SpeedIcon from '@mui/icons-material/Speed';
import SecurityIcon from '@mui/icons-material/Security';
import DevicesIcon from '@mui/icons-material/Devices';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CarouselBanner from '../components/CarouselBanner';
import EnquiryForm from '../components/EnquiryForm';

const FeatureIcon = styled(Box)(({ theme }) => ({
  fontSize: '3rem',
  color: theme.palette.secondary.main,
  marginBottom: theme.spacing(2),
}));

function Home() {
  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);

  const handleEnquiryOpen = () => {
    setIsEnquiryOpen(true);
  };

  const handleEnquiryClose = () => {
    setIsEnquiryOpen(false);
  };

  const features = [
    {
      icon: <SpeedIcon fontSize="inherit" />,
      title: 'Quick Process',
      description: 'Get your loan approved in minutes with our streamlined process',
    },
    {
      icon: <SecurityIcon fontSize="inherit" />,
      title: 'Secure Application',
      description: '100% secure and confidential loan application process',
    },
    {
      icon: <DevicesIcon fontSize="inherit" />,
      title: '100% Online',
      description: 'Complete your loan application process from anywhere',
    },
    {
      icon: <CheckCircleIcon fontSize="inherit" />,
      title: 'Same Day Approval',
      description: 'Get your loan approved on the same day of application',
    },
  ];

  return (
    <>
      <CarouselBanner onApplyClick={handleEnquiryOpen} />

      {/* Features Section */}
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
        <Typography 
          variant="h4" 
          align="center" 
          gutterBottom
          sx={{
            fontSize: { xs: '1.75rem', md: '2.25rem' },
            fontWeight: 'bold',
            mb: 6,
          }}
        >
          Why choose us for quick loans?
        </Typography>
        <Grid container spacing={4}>
          {features.map((feature) => (
            <Grid item xs={12} sm={6} md={3} key={feature.title}>
              <Card 
                sx={{ 
                  height: '100%', 
                  textAlign: 'center',
                  transition: 'transform 0.2s',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                  },
                }}
              >
                <CardContent>
                  <FeatureIcon>{feature.icon}</FeatureIcon>
                  <Typography variant="h6" gutterBottom>
                    {feature.title}
                  </Typography>
                  <Typography color="text.secondary">
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Testimonials Section */}
      <Box sx={{ bgcolor: 'grey.100', py: { xs: 6, md: 8 } }}>
        <Container maxWidth="lg">
          <Typography 
            variant="h4" 
            align="center" 
            gutterBottom
            sx={{
              fontSize: { xs: '1.75rem', md: '2.25rem' },
              fontWeight: 'bold',
              mb: 6,
            }}
          >
            What our clients say about us
          </Typography>
          <Grid container spacing={4}>
            {[
              {
                text: "Thank you Aaradhya Finance for making my dream home a reality. The process was smooth and hassle-free.",
                name: "Rajesh Kumar",
              },
              {
                text: "Excellent service and professional team. Got my loan approved within days. Highly recommended!",
                name: "Priya Sharma",
              },
              {
                text: "Best interest rates and transparent process. The team guided me throughout the loan process.",
                name: "Amit Patel",
              },
            ].map((testimonial) => (
              <Grid item xs={12} md={4} key={testimonial.name}>
                <Card 
                  sx={{ 
                    height: '100%',
                    transition: 'transform 0.2s',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                    },
                  }}
                >
                  <CardContent>
                    <Typography 
                      variant="body1" 
                      paragraph 
                      sx={{ 
                        fontStyle: 'italic',
                        fontSize: { xs: '1rem', md: '1.1rem' },
                        mb: 3,
                      }}
                    >
                      "{testimonial.text}"
                    </Typography>
                    <Typography 
                      variant="subtitle1" 
                      color="primary" 
                      sx={{ 
                        fontWeight: 'bold',
                        fontSize: { xs: '1.1rem', md: '1.2rem' },
                      }}
                    >
                      {testimonial.name}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      <EnquiryForm 
        open={isEnquiryOpen} 
        onClose={handleEnquiryClose} 
      />
    </>
  );
}

export default Home; 